export default "__VITE_ASSET__CYl79q45__"